import { render, staticRenderFns } from "./ZoteroHint.vue?vue&type=template&id=c448287c&scoped=true&"
import script from "./ZoteroHint.vue?vue&type=script&lang=js&"
export * from "./ZoteroHint.vue?vue&type=script&lang=js&"
import style0 from "./ZoteroHint.vue?vue&type=style&index=0&id=c448287c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448287c",
  null
  
)

export default component.exports